import PersistentStore from '../stores/PersistentStore.js';
import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';
import commonUtils from '../utils/commonUtils.js';

import Header from './Header.js';

import './App.css';

function renderHighScoreItem(item, currentScore) {
  if (!item) {
    return null;
  }
  const itemDisplay = commonUtils.getDisplayTime(item.score);
  const itemDateObj = new Date(item.time);
  const timeString = itemDateObj.toLocaleString();

  if (currentScore?.time === item.time) {
    return (
      <div key={item.time}>
        <b>
          Score {itemDisplay} on {timeString}.<br/>
        </b>
      </div>
    );
  }
  return (
    <div key={item.time}>
      Score {itemDisplay} on {timeString}.<br/>
    </div>
  );
}

function renderHighScore(highScores, currentScore) {
  const result = [];
  highScores.forEach((item) => {
    result.push(renderHighScoreItem(item, currentScore));
  });

  return result;
}

function PageDone() {
  useStores([SessionStore]);

  const currentScore = PersistentStore.getScore();
  const highScores = PersistentStore.getHighScores();
  const elapsedTime = SessionStore.getElapsedTime();
  const elapsedDisplay = commonUtils.getDisplayTime(elapsedTime);
  const failureCount = SessionStore.getFailureCount();
  const scoreDisplay = commonUtils.getDisplayTime(currentScore.score);
  const renderedHighScores = renderHighScore(highScores, currentScore);

  return (
    <>
      <Header />

      <div className="middle large">
        <p>
          ¡Hecho!
        </p>

        <p>
          Has tardado {elapsedDisplay} horas en esta partida con {failureCount} errores.

Esto te da una puntuación final de {scoreDisplay}.
        </p>
        <b>Mejores puntuaciones:</b>
        {renderedHighScores}
      </div>
      <div className="bottom">
        <div class="buttons">
          <button
            onClick={() => {
              SessionStore.backToStart();
            }}
          >
            Iniciar un nuevo juego
          </button>
        </div>
      </div>
    </>
  );
}

export default PageDone;
